import React from "react";
import PropTypes from "prop-types";

import PageNavigator from "../PageNavigator";
import PageJumpLabel from "../PageJumpLabel";
import { pluralizeWithNum } from "../../utilities/utilities";

const CustomPagination = ({
	data,
	rowCount,
	page,
	pages,
	onPageChange,
	showPageCount = true,
	itemNoun,
}) => {
	// rows visible after filtering
	const count = rowCount ?? data.length;
	return (
		<div
			style={{
				border: "1px solid rgba(0, 0, 0, 0.15)",
				borderTop: "1px solid black",
				display: "flex",
				alignItems: "center",
				height: 36,
				lineHeight: "36px",
			}}
		>
			<PageNavigator
				page={page + 1}
				totalPages={pages}
				onChange={(p) => onPageChange(p - 1)}
				style={{ marginLeft: 8, marginRight: 15 }}
			/>
			{showPageCount ? (
				<div className="PaginationSummary">
					<PageJumpLabel
						page={page + 1}
						totalPages={pages}
						onChange={(p) => onPageChange(p - 1)}
						style={{ marginRight: 8 }}
					/>
					<span> {`(${count} total items)`}</span>
				</div>
			) : (
				<div className="PaginationSummary">
					{itemNoun
						? pluralizeWithNum(itemNoun, count)
						: `${count} total items`}
				</div>
			)}
		</div>
	);
};

CustomPagination.propTypes = {
	data: PropTypes.array,
	rowCount: PropTypes.number,
	pages: PropTypes.number,
	page: PropTypes.number,
	onPageChange: PropTypes.func,
	showPageCount: PropTypes.bool,
	itemNoun: PropTypes.string,
};

// Shows only the item count, e.g. "59 Folders", instead of "Page X of Y"
const itemCountPagination = (itemNoun) => {
	const ItemCountPagination = (props) => (
		<CustomPagination
			{...props}
			showPageCount={false}
			itemNoun={itemNoun}
		/>
	);
	return ItemCountPagination;
};

export { itemCountPagination };
export default CustomPagination;
